import React, { useEffect, useState } from "react";
import ScrollableBox from "../widget/ScrollableBox";
import compress from '../../assets/images/compress.svg';
import expand from '../../assets/images/expand.svg';

const PopupEntry = ({ name, value, isExpandable = false, resetTrigger }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = () => setExpanded(!expanded);

    const isLongText = isExpandable && value.length > 400;

    // Reset expanded state when resetTrigger changes
    useEffect(() => {
        setExpanded(false);
    }, [resetTrigger]);

    return (
        <div key={name} className="scrollable_info_popup_entry">
            <span className="font-medium semibold" style={{ display: "inline-block" }}>{name}:</span>
            <span className="font-medium" style={{ display: "inline-block" }}>
                {isLongText && !expanded ? (
                    <>
                        {value.slice(0, 400)}...
                        <br />
                        <a href="#" onClick={(e) => { e.preventDefault(); toggleExpanded(); }} 
                            style={{ color: "blue", cursor: "pointer" }}>
                            more
                        </a>
                    </>
                ) : (
                    <>
                        {value}
                        {isLongText && (
                            <>
                                <br />
                                <a href="#" onClick={(e) => { e.preventDefault(); toggleExpanded(); }} 
                                    style={{ color: "blue", cursor: "pointer" }}>
                                    hide
                                </a>
                            </>
                        )}
                    </>
                )}
            </span>
        </div>
    );
};

const ScrollableInfoPopup = ({ content }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [resetTrigger, setResetTrigger] = useState(0); // Used to trigger resets

    useEffect(() => {
        setResetTrigger(prev => prev + 1); // Increment to trigger resets
    }, [content]); // Runs when content changes (new popup opens)

    let display = content === null ? "none" : "";
    let embedding = null;
    let groupAttributes = null;
    let instanceAttributes = null;

    if (content !== null) {
        embedding = content["embedding"];
        groupAttributes = content["groupAttributes"];
        instanceAttributes = content["instanceAttributes"];

        const format_coordinate = (val) => Number(val).toPrecision(4);
        embedding = embedding.map(format_coordinate);
    }

    const section = (headline, entries) => (
        <div className="scrollable_info_popup_section">
            <h2 className="bold">{headline}</h2>
            {Object.entries(entries).map(([key, value]) => (
                <PopupEntry key={key} name={key} value={value} isExpandable={key === "full document text"} resetTrigger={resetTrigger} />
            ))}
        </div>
    );

    return (
        <div id="scrollable_info_popup" style={{
            zIndex: 100,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: display,
        }}>
            <div style={{ position: "relative"}}>
                {/* Expand/Collapse Icon */}
                <button 
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    {isExpanded ? <img src={compress} style={{ width: "20px" }} /> : <img src={expand} style={{ width: "20px" }} />}
                </button>

                <ScrollableBox 
                    id="scrollable_info_popup_box"
                    display=""
                    width={isExpanded ? "calc(100vw - 100px)" : "600px"} 
                    maxHeight={isExpanded ? "calc(100vh - 100px)" : "600px"} 
                    style={isExpanded ? { margin: "50px" } : {}}
                    clearable={true}
                >
                    {content !== null ? (
                        <div id="scrollable_info_popup_content" style={{padding:"20px 35px"}}>
                            <h1>Detailed Information: {instanceAttributes["id"]}</h1>
                            <div className="scrollable_info_popup_section">
                                <h2 className="bold">Coordinates:</h2>
                                <span className="font-medium" style={{ display: "inline-block" }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        {"("}
                                        {embedding.map((coord, index) => (
                                            <div key={index} style={{ marginRight: '3px' }}>
                                                {coord}{index === (embedding.length - 1) ? "" : ","}
                                            </div>
                                        ))}
                                        {")"}
                                    </div>
                                </span>
                            </div>
                            {section("Grouping:", groupAttributes)}
                            {section("Data:", instanceAttributes)}
                        </div>
                    ) : "No content to display"}
                </ScrollableBox>
            </div>
        </div>
    );
};

export default ScrollableInfoPopup;

